import projectsHero from "../images/projects_hero.svg";
import ssoImage from "../images/projects/sso.png";
import BaseGImageCustomers from "../images/projects/10BaseG_Customers.png";
import BaseGImageContacts from "../images/projects/10BaseG_Contacts.png";
import azureMLImage from "../images/projects/AzureML.png";
import dommicroLogo from "../images/logos/DOMMICRO.svg";
import talkForTyLogo from "../images/logos/TalkForTy.png";
import tftWebDashboard from "../images/projects/talkforty/11-web-dashboard.png";
import tftUserPortal from "../images/projects/talkforty/10-user-portal.png";
import tftWebMarketing from "../images/projects/talkforty/12-web-marketing.png";

export const Projects = () => {
  return (
    <>
      <div className="pageHero">
        <div className="pageHeroText">
          <h1 className="pageHeroTitle">Projects</h1>
          <p className="pageHeroSubtitle">
            Real-world solutions we have delivered or have currently in progress —
            spanning identity, CRM, machine learning, and modern AAC communication
            platforms. Our newest engagements are built with AI and agentic coding
            at the core.
          </p>
        </div>
        <div className="pageHeroImageWrap hide-on-mobile">
          <img src={projectsHero} alt="Projects showcase" className="pageHeroImg" />
        </div>
      </div>

      <div className="pageContent">

        <div className="serviceSection">
          <h3 className="sectionTitle" style={{ display: "block", textAlign: "center", borderBottom: "none", paddingBottom: 0 }}>AI &amp; Agentic Capabilities</h3>
          <p style={{ maxWidth: "740px", margin: "4px auto 28px", textAlign: "center" }}>
            A snapshot of where AI and agentic coding show up across the
            capabilities we bring to most new engagements.
          </p>
          <div className="aiCardsRow">
            <div className="aiFeatureCard">
              <h6>Intelligent Identity Verification</h6>
              <p>
                Layer AI-powered anomaly detection and behavioral analytics on top
                of existing identity infrastructure to flag suspicious logins and
                prevent account takeover in real time.
              </p>
            </div>
            <div className="aiFeatureCard">
              <h6>AI-Augmented CRM</h6>
              <p>
                Embed predictive lead scoring, churn risk detection, and natural
                language summaries directly into CRM workflows so your team focuses
                on the highest-value opportunities.
              </p>
            </div>
            <div className="aiFeatureCard">
              <h6>Automated ML Pipelines</h6>
              <p>
                End-to-end MLOps on Azure — automated retraining, drift detection,
                model versioning, and one-click deployment so your models stay
                accurate as data evolves.
              </p>
            </div>
            <div className="aiFeatureCard">
              <h6>Agentic Coding</h6>
              <p>
                We deliver client engagements using modern agentic coding tools —
                accelerating implementation, expanding test coverage, and shortening
                review cycles so you get production-ready software faster and at lower cost.
              </p>
            </div>
          </div>
        </div>

        <div className="sectionDivider" />

        <div className="serviceSection">
          <div className="projectCard">
            <h4>Agentic Coding</h4>
            <p>
              Most of our new engagements are now delivered with agentic coding
              tools — Claude Code, Cursor, GitHub Copilot, and custom agent
              workflows tuned to each client&rsquo;s stack. We pair senior
              engineering judgment with AI agents that handle scaffolding,
              refactoring, test generation, and code review at machine speed,
              so your software ships faster without cutting corners on quality.
            </p>
            <p>
              <strong>What this means for you:</strong>
            </p>
            <ul style={{ marginTop: "-8px", marginBottom: "12px" }}>
              <li>
                <strong>Faster delivery</strong> — features and migrations that used
                to take weeks land in days, with no compromise on review rigor.
              </li>
              <li>
                <strong>Higher quality</strong> — broader test coverage, consistent
                style and patterns, and fewer regressions because agents enforce
                conventions tirelessly.
              </li>
              <li>
                <strong>Lower cost</strong> — fewer billable hours per outcome, which
                we pass through as more competitive engagement pricing.
              </li>
              <li>
                <strong>Stronger documentation</strong> — every change ships with
                clear PR summaries, updated docs, and a trail your team can audit.
              </li>
            </ul>
            <p>
              The TalkForTy mobile app, web admin console, and supporting Azure
              infrastructure shown below were all delivered using this approach.
            </p>
          </div>
        </div>

        <div className="sectionDivider" />

        <div className="serviceSection">
          <div className="projectCard">
            <div style={{ display: "flex", alignItems: "center", gap: "16px", marginBottom: "12px" }}>
              <img
                src={dommicroLogo}
                alt="DOMMICRO logo"
                style={{ width: "56px", height: "56px", borderRadius: "10px", objectFit: "contain" }}
              />
              <h4 style={{ margin: 0 }}>Single Sign-On Solution</h4>
            </div>
            <p>
              Simplify your login experience with Azure B2C. We design and implement
              single sign-on across multiple applications so your users authenticate
              once and access everything they need, with full support for external
              identity providers including Google, Facebook, LinkedIn, Active
              Directory, and Azure Active Directory.
            </p>
            <div className="projectScreenshots">
              <img src={ssoImage} alt="Single Sign-On Solution" />
            </div>
          </div>
        </div>

        <div className="sectionDivider" />

        <div className="serviceSection">
          <div className="projectCard">
            <div style={{ display: "flex", alignItems: "center", gap: "16px", marginBottom: "12px" }}>
              <img
                src={talkForTyLogo}
                alt="TalkForTy logo"
                style={{ width: "56px", height: "56px", borderRadius: "10px" }}
              />
              <h4 style={{ margin: 0 }}>
                <a
                  href="https://talkforty.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "inherit", textDecoration: "none" }}
                >
                  TalkForTy
                </a>
              </h4>
            </div>
            <p>
              A mobile-first augmentative and alternative communication (AAC) app
              that gives individuals with speech challenges a fast, intuitive way
              to express themselves — tapping picture-based cards that speak for
              them with high-quality voice synthesis. Designed around the picture
              exchange communication system (PECS), the app supports customizable
              voices, favorites, recent history, category navigation, and
              per-user personalization so each person can communicate in the way
              that fits them best.
            </p>
            <p>
              Built with React Native for a smooth, native experience on both
              iOS and Android, and backed by a React + Azure web platform that
              gives caregivers and administrators a control panel for managing
              cards and categories, plus a self-service portal for accounts and
              configuration. Visit <a href="https://talkforty.com/" target="_blank" rel="noopener noreferrer">talkforty.com</a> to learn more.
            </p>
            <div className="projectScreenshots">
              <img src={tftWebMarketing} alt="TalkForTy web - Marketing landing page" />
              <img src={tftUserPortal} alt="TalkForTy web - User account portal" />
              <img src={tftWebDashboard} alt="TalkForTy web admin - Control panel dashboard" />
            </div>
          </div>
        </div>

        <div className="sectionDivider" />

        <div className="serviceSection">
          <div className="projectCard">
            <h4>Customer Management &amp; Tracking</h4>
            <p>
              Build stronger customer relationships with a tailored CRM platform.
              Our custom 10BaseG solution gives your team a single view of every
              customer — contacts, history, interactions, and opportunities — so
              you can act on insights faster, improve satisfaction, and grow revenue.
            </p>
            <div className="projectScreenshots">
              <img src={BaseGImageCustomers} alt="Customer management dashboard" />
              <img src={BaseGImageContacts} alt="Contact management dashboard" />
            </div>
          </div>
        </div>

        <div className="sectionDivider" />

        <div className="serviceSection">
          <div className="projectCard">
            <h4>Azure Machine Learning</h4>
            <p>
              We leverage Azure Machine Learning to build, train, and deploy
              predictive models in the cloud. From data preparation and feature
              engineering through model evaluation and production deployment,
              we help data scientists and developers deliver ML solutions
              faster and more reliably.
            </p>
            <div className="projectScreenshots">
              <img src={azureMLImage} alt="Azure Machine Learning pipeline" />
            </div>
          </div>
        </div>

        <div className="sectionDivider" />

        <div className="serviceSection">
          <div className="projectCard">
            <h4>And More</h4>
            <p>
              The projects above are a representative sample, not the full
              catalog. We regularly take on engagements across:
            </p>
            <ul style={{ marginTop: "-4px", marginBottom: "12px" }}>
              <li>
                <strong>Websites &amp; marketing sites</strong> — responsive,
                SEO-friendly builds from landing pages to multi-page brand sites.
              </li>
              <li>
                <strong>Web applications</strong> — SaaS products, internal
                dashboards, admin portals, and multi-tenant platforms with
                authentication, role-based access, and reporting.
              </li>
              <li>
                <strong>Mobile applications</strong> — native and cross-platform
                iOS and Android apps, including offline-first and accessibility-focused builds.
              </li>
              <li>
                <strong>APIs &amp; integrations</strong> — REST and GraphQL APIs,
                third-party service integrations, webhook pipelines, and
                automation glue between systems.
              </li>
            </ul>
            <p>
              Have something that does not fit neatly into a category? Reach out —
              we are happy to scope it.
            </p>
          </div>
        </div>

      </div>
    </>
  );
};
